<template>
    <v-container fluid class="pa-0">
        <skeleton-loader type="detail" v-if="loading" />
        <template v-else-if="routine">
            <routine-detail :routine="routine" program-mode @edit="openEditor" />
            <program-routine-editor ref="editor" @success="onRoutineSaved" />
        </template>
    </v-container>
</template>

<script>

import RoutineDetail from '@/components/coach/routines/RoutineDetail'
import ProgramRoutineEditor from '@/components/coach/routines/ProgramRoutineEditor'
import { db } from "@/utils/Firebase";
import { getMergedBlocks } from "@/utils/Exercises";
import SkeletonLoader from "@/components/common/SkeletonLoader";

export default {
    components: { SkeletonLoader, RoutineDetail, ProgramRoutineEditor },
    data() {
        return {
            loading: false,
            program: null,
        }
    },
    computed: {
        programId(vm = this) {
            return vm.$route.params.uid || null
        },
        routineId(vm = this) {
            return vm.$route.params.id
        },
        routine(vm = this) {
            const routine = vm.program?.assignedRoutines?.[vm.routineId]
            if (!routine) return null
            return {
                ...routine,
                name: `${vm.$t('programs.routine_name')} ${Number(vm.routineId || 0) + 1}`,
                coachId: vm.program?.coachId || null,
            }
        },
    },
    async mounted() {
        await this.loadProgram()
    },
    methods: {
        async loadProgram() {
            const vm = this
            await vm.withLoading(async () => {
                const programRef = await db.collection('programs').doc(vm.programId).get()
                const program = programRef.data()
                for (let routine of (program?.assignedRoutines || [])) {
                    routine.blocks = await getMergedBlocks(routine.blocks)
                }
                vm.program = program
            })
        },
        openEditor() {
            const vm = this
            vm.$refs.editor.show({ programId: vm.programId, routineId: vm.routineId })
        },
        onRoutineSaved({ blocks }) {
            const vm = this
            const idx = Number(vm.routineId)
            const updated = { ...vm.program.assignedRoutines[idx], blocks }
            vm.program.assignedRoutines.splice(idx, 1, updated)
        },
    },
}
</script>
